import config from '../config'
import {dateAheadFormat, javaTimeToBj} from '@spero/spero-utils/src/helpers/date'
import dateformat from 'dateformat'
export default {
  data () {
    return {
      inApp: !!window.navigator.userAgent.match(/vsnapp/gi) || !!process.env.APP,
      isWechat: /MicroMessenger/i.test(navigator.userAgent),
      os: window.navigator.userAgent.match(/ios|iphone|ipad/gi)
        ? 'ios'
        : window.navigator.userAgent.match(/android/gi)
          ? 'android'
          : 'other',
      isPC: !(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
    }
  },
  methods: {
    authInWechat (act, url) {
      url = url || location.href
      let auth = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appid + '&redirect_uri='
      let redirectUri = encodeURIComponent(url)
      let other = '&response_type=code&scope=snsapi_userinfo&state=' + act + '#wechat_redirect'
      return auth + redirectUri + other
    },
    urlJump (jumpUrl) {
      if (/^spero/.test(jumpUrl)) {
        const {event: {navigate}} = window.speroBridge
        window.YTXBridge && window.YTXBridge.fireEvent(navigate, {
          schema: jumpUrl,
          data: {}
        })
      } else {
        location.href = jumpUrl
      }
    },
    // 时间转化
    getFormateDate (val) {
      return dateAheadFormat(javaTimeToBj(val), [
        {
          seconds: 60,
          format: '刚刚'
        },
        {
          seconds: 3600,
          rate: 60,
          format: '分钟前'
        },
        {
          seconds: 86400,
          rate: 3600,
          format: '小时前'
        },
        {
          seconds: function () {
            let n = new Date()
            let y = n.getFullYear()
            let m = n.getMonth()
            let d = n.getDate()
            let zero = new Date(y, m, d, 0, 0, 0)
            return Math.floor((n.getTime() - zero.getTime()) / 1000) + 86400
          },
          format: function (v, f = 'HH:MM') {
            return '昨日' + ' ' + dateformat(v, f)
          }

        },{
          seconds: function () {
            let n = new Date()
            let y = n.getFullYear()
            let zero = new Date(y, 0, 1, 0, 0, 0)
            return Math.floor((n.getTime() - zero.getTime()) / 1000) + 86400
          },
          format: function (v, f = 'mm-dd HH:MM') {
            return dateformat(v, f)
          }
        }, {
          format: 'yyyy-mm-dd HH:MM'
        }
      ])
    },
    async wechatShare (options, timelineLink, chatLink, callback) {
      /*
      * options[Object]
      *   title 标题
      *   desc 描述
      *   imgUrl 缩略图
      * */
      if (!this.isWechat) {
        return
      }
      await this.$wechat.config()

      this.$wechat.onMenuShareTimeline({
        link: timelineLink,
        ...options,
        success: () => {
          let type = 1
          callback(type)
        }
      })
      this.$wechat.onMenuShareAppMessage({
        link: chatLink,
        ...options,
        success: () => {
          let type = 2
          callback(type)
        }
      })
    }
  }
}
